module.exports = __webpack_public_path__ + "static/financial-2-dda4adea9a59af213e380c7c6bf74879.svg";